import { currencyFormatter } from "../../common/helpers/currency";
import { ReconciledIcon, UnreconciledIcon } from "../../icons";
import styles from "./Reconciliation.module.scss";

interface Props {
    difference: number;
}

export const ReconciliationBalanceDifference: React.FC<Props> = ({
    difference,
}) => (
    <div className={styles.balanceDifference}>
        <div className={styles.balanceDifferenceContent}>
            {difference === 0 ? (
                <ReconciledIcon className="icon-color-current" />
            ) : (
                <UnreconciledIcon className="icon-color-current" />
            )}
            Difference
            <span className={styles.balanceDifferenceAmount}>
                {currencyFormatter.format(difference)}
            </span>
        </div>
    </div>
);
